export default function ArrowRecalculation({ children }) {
  return <>{children}</>;
}
